<template>
  <b-col class="d-flex align-items-center justify-content-end pl-0">
    <span class="dark">{{ filter ? filter.translatedName : $t('configuration.modal.allGroups') }}
      <b-button
        :id="targetId"
        class="btn__icon btn__icon--primary  pl-2 pr-0"
      >
        <i
          class="far fa-chevron-down"
          aria-hidden="true"
        />
      </b-button>
    </span>
    <b-popover
      :target="targetId"
      placement="bottom"
      triggers="click blur"
    >
      <div class="operation-group-pop ap-popover">
        <div class="pop-header">
          <span class="label-dark">{{ $t('configuration.modal.selectGroup') }}</span>
        </div>
        <ul>
          <li
            class="label-dark"
            @click="filter = null"
          >
            {{ $t('configuration.modal.allGroups') }}
          </li>
          <div class="horizontal-divider my-0" />
          <li
            v-for="(group, i) in OPERATION_GROUP"
            :key="i"
            @click="filter = group"
          >
            <div class="d-flex label-dark">
              <div class="group-icon alt-primary d-flex align-items-center justify-content-center">
                <i
                  :class="OPERATION_GROUP[group.value].icon"
                  aria-hidden="true"
                />
              </div>
              {{ OPERATION_GROUP[group.value].translatedName }}
            </div>
          </li>
        </ul>
      </div>
    </b-popover>
  </b-col>
</template>

<script>
import { OPERATION_GROUP } from '@/api/resources/configuration/peopleManagement/OperationGroups'

export default {
    name: 'OperationGroupFilter',
    props: {
        targetId: {
            type: String,
            default: 'target'
        }
    },
    data() {
        return {
            filter: null
        }
    },
    computed: {
        OPERATION_GROUP() {
            return OPERATION_GROUP
        }
    },
    watch: {
        filter() {
            this.$emit('change', this.filter)
        }
    }
}
</script>

<style lang="scss">
    .operation-group-pop .group-icon,
    .check-column.group .group-icon {
        width: 15px;
        margin-right: 10px;
        text-align: center;
    }
    .operation-group-pop {
        padding: 0 !important;
        box-shadow: 0px 2px 5px 0px #9c9c9c;
    }
    .operation-group-pop ul {
        padding: 0;
        margin: 5px 0;
    }
    .operation-group-pop ul li {
        list-style: none;
        padding: 5px 20px;
        font-size: 12px;
        cursor: pointer;
    }
    .operation-group-pop ul li:hover {
        background: vt-color(light-primary);
    }
    .operation-group-pop .pop-header {
        background: vt-color(base-text, .9);
        padding: 8px 12px;
        font-weight: 700;
    }
</style>
